import React from "react";
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "./testimonial.css";

const testimonials = [
  {
    img: "https://i.ibb.co/hKgs8gm/profile.jpg",
    name: "John Doe",
    role: "Manager",
    text: "Lorem ipsum dolor sit amet consectetur adipisicing elit."
  },
  {
    img: "https://i.ibb.co/JQ18QKW/asd.jpg",
    name: "Jane Smith",
    role: "CEO",
    text: "Delectus optio facilis beatae."
  },
  {
    img: "https://i.ibb.co/hKgs8gm/profile.jpg",
    name: "Alex",
    role: "Developer",
    text: "Sed do eiusmod tempor incididunt."
  }
];

function Testimonial() {
  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    autoplay: false,
    responsive: [
      {
        breakpoint: 991,
        settings: { slidesToShow: 2 }
      },
      {
        breakpoint: 575,
        settings: { slidesToShow: 1 }
      }
    ]
  };

  return (
    <section className="testimonial mt-2">
      <div className="container">

        <h2 className='heading'>Testimonials</h2>
        <Slider {...settings}>
          {testimonials.map((item, i) => (
            <div key={i} className="testimonial-slide">
              <div className="testimonial_box">
                <div className="testimonial_box-top">
                  <div className="testimonial_box-text">
                    <p>{item.text}</p>
                  </div>
                </div>

                <div className="testimonial_box-bottom">
                  <div className="testimonial_box-profile">
                    <img src={item.img} alt="" />
                    <div>
                      <h4>{item.name}</h4>
                      <p>{item.role}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
}

export default Testimonial;